// User header component with logout
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const UserHeader = () => {
    const { user, logout } = useAuth();

    if (!user) return null;

    return (
        <div style={{
            background: '#000000',
            color: 'white',
            padding: '0.75rem 1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '0.9rem',
            borderBottom: '1px solid #333333'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                    background: '#333333',
                    color: 'white',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '12px',
                    fontSize: '0.8rem',
                    border: '1px solid #555555'
                }}>
                    {user.role === 'admin' ? '👑 Admin' : '👤 Analyst'}
                </div>
                <span style={{ fontWeight: '500', color: 'white' }}>
                    {user.name} ({user.company})
                </span>
            </div>
            <button
                onClick={logout}
                style={{
                    background: '#333333',
                    color: 'white',
                    border: '1px solid #555555',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.85rem',
                    transition: 'all 0.2s',
                    fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                    e.target.style.background = '#555555';
                    e.target.style.borderColor = '#777777';
                }}
                onMouseLeave={(e) => {
                    e.target.style.background = '#333333';
                    e.target.style.borderColor = '#555555';
                }}
            >
                Logout
            </button>
        </div>
    );
};

export default UserHeader;